import { Pipe, PipeTransform } from '@angular/core';
import { ICardCollection } from 'src/app/models/collection';

@Pipe({
  name: 'totalViews',
  pure: true
})
export class TotalViewsPipe implements PipeTransform {
  transform(collection: ICardCollection): number {
    if (!collection?.collectionCards?.length) {
      return 0;
    }
    return collection.collectionCards.reduce((sum, card) => sum + (card.views || 0), 0);
  }
}
